export default "__VITE_ASSET__70b8002a__"